import React, { useState, useEffect, useRef } from "react";
import { Modal, Button, Input } from "antd";
import "./AadharOtpModal.css";

const AadharOtpModal = ({ visible, onCancel, onVerify, invalid }) => {
  const [otp, setOtp] = useState(Array(6).fill(""));
  const [timer, setTimer] = useState(30);
  const inputRefs = useRef([]);
  const timerRef = useRef(null);

  // Start/reset timer
  useEffect(() => {
    if (visible) {
      setOtp(Array(6).fill(""));
      setTimer(30);
      setTimeout(() => inputRefs.current[0]?.focus(), 100);
      startTimer();
    } else {
      stopTimer();
    }
    return () => stopTimer();
  }, [visible]);

  const startTimer = () => {
    stopTimer();
    timerRef.current = setInterval(() => {
      setTimer((prev) => {
        if (prev === 1) {
          clearInterval(timerRef.current);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };

  const stopTimer = () => {
    if (timerRef.current) {
      clearInterval(timerRef.current);
      timerRef.current = null;
    }
  };

  const handleChange = (e, index) => {
    const value = e.target.value;
    if (!/^\d$/.test(value)) return;

    const updatedOtp = [...otp];
    updatedOtp[index] = value;
    setOtp(updatedOtp);

    if (index < 5 && inputRefs.current[index + 1]) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      const updatedOtp = [...otp];
      if (otp[index]) {
        updatedOtp[index] = "";
        setOtp(updatedOtp);
      } else if (index > 0) {
        updatedOtp[index - 1] = "";
        setOtp(updatedOtp);
        if (inputRefs.current[index - 1]) {
          inputRefs.current[index - 1].focus();
        }
      }
    }
  };

  const handlePaste = (e) => {
    const pasted = e.clipboardData.getData("text").replace(/\D/g, "");
    if (pasted.length !== 6) return;

    const newOtp = pasted.split("").slice(0, 6);
    setOtp(newOtp);

    if (inputRefs.current[5]) {
      inputRefs.current[5].focus();
    }
  };

  const handleVerify = () => {
    const otpValue = otp.join("");
    onVerify(otpValue);
  };

  const handleResend = () => {
    setOtp(Array(6).fill(""));

    if (inputRefs.current[0]) {
      inputRefs.current[0].focus();
    }

    setTimer(30);
    startTimer();
  };

  return (
    <Modal
      open={visible}
      title="Enter AADHAR OTP"
      onCancel={onCancel}
      footer={null}
      centered
    >
      <div className="otp-modal-content">
        <p>OTP has been sent to your registered mobile number</p>
        <p>Enter 6 digit OTP</p>

        <div className="otp-input-container" onPaste={handlePaste}>
          {otp.map((digit, index) => (
            <Input
              key={index}
              ref={(el) => (inputRefs.current[index] = el)}
              value={digit}
              maxLength={1}
              onChange={(e) => handleChange(e, index)}
              onKeyDown={(e) => handleKeyDown(e, index)}
              className="otp-box"
              inputMode="numeric"
            />
          ))}
        </div>
        {invalid ? (
          <div className="wrong-text">
            <span>The OTP you entered is incorrect</span>
          </div>
        ) : null}

        <div className="resend-text">
          {timer > 0 ? (
            <span>Didn't receive OTP? Resend in {timer} secs</span>
          ) : (
            <span className="resend" onClick={handleResend}>
              Resend OTP
            </span>
          )}
        </div>

        <div className="otp-button-group">
          <Button onClick={onCancel}>Cancel</Button>
          <Button
            type="primary"
            onClick={handleVerify}
            disabled={otp.includes("")}
          >
            Verify AADHAR
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default AadharOtpModal;
